import * as contentful from 'contentful';

export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig()
  if (!config.public.contentfulAccessToken || !config.public.contentfulSpaceId) return

  const client = contentful.createClient({
    space: config.public.contentfulSpaceId,
    accessToken: config.public.contentfulAccessToken,
    environment: config.public.contentfulEnvironment,
  })
  nuxtApp.provide('contentfulClient', client)

  try {
    const entries = await client.getEntries()
    entries.items.sort((a, b) => {
      const dateA = a.fields?.backDate ? new Date(a.fields.backDate) : new Date(a.sys.createdAt)
      const dateB = b.fields?.backDate ? new Date(b.fields.backDate) : new Date(b.sys.createdAt)
      return dateB - dateA
    })
    useBlog().setEntries(entries);
  } catch (error) {
    console.error('Blog posts could not be loaded', error)
  }
})
